import InputC from 'Common/Inputs/index.tsx';
import React, { Fragment, useState } from 'react';

const CommonTableDrived = ({
  Label = 'View',
  Option = [
    { id: 1, name: 'Grid', value: 1, label: 'Grid' },
    { id: 2, name: 'List', value: 2, label: 'List' },
  ],
  ClickedValue,
  selectedValueData = { id: 1, name: 'Grid', value: 1, label: 'Grid' },
}) => {
  const [value, selectedValue] = useState(selectedValueData);

  return (
    <Fragment>
      <div className="d-flex gap-2 align-items-center mt-2">
        <div className="grid_label">{Label}</div>
        <InputC
          type="select"
          label=""
          options={Option}
          change={(value) => {
            localStorage.setItem('viewMode', JSON.stringify(value));
            ClickedValue(value);
            selectedValue(value);
          }}
          value={value?.id}
          inputvalue={value?.id}
          isClearable={false}
        />
      </div>
    </Fragment>
  );
};

export default CommonTableDrived;
